import React, { memo } from 'react'
import { HashRouter, Switch, Route } from 'react-router-dom'
import Index from './pages/index'
import Sjfb from './pages/sjfbjd'
import Tjbk from './pages/tjbk'
import Tjsj from './pages/tjsj'
const App = memo(() => {
  return (
    <div className='app'>
      <HashRouter>
        <Switch>
          <Route exact path='/' component={Index} />
          <Route exact path='/lxwm' component={Tjbk} />
          <Route exact path='/zzdw' component={Tjsj} />
          <Route path='/content/:id' render={() => <Sjfb />} />
        </Switch>
      </HashRouter>
    </div>
  )
})

export default App;
